import SecureUploadPage from './components/SecureUploadPage';

export default SecureUploadPage;
